import { createTheme } from "@mui/material";
import { tokens } from "./Tokens";

const optionStyleOverrides = {
  styleOverrides: {
    root: {
      borderRadius: "4px",

      "& .MuiSvgIcon-root": {
        height: "20px",
        width: "20px",

        path: {
          borderRadius: "4px",
          fill: tokens.Border.General.Color
        }
      },
      icon: {
        "& svg": {
          borderRadius: "4px"
        }
      },
      "&:hover": {
        color: tokens.Primary.Primary400
      },
      "&.Mui-focusVisible span": {
        "&:first-child": {
          color: "transparent"
        },
        "&:nth-child(2)": {
          boxShadow: `inset 0px 0px 0px 2px ${tokens.Primary.Primary200}`,
          borderRadius: "50%"
        }
      },
      // "&.Mui-checked .MuiSvgIcon-root": {
      //   fill: tokens.Primary.Primary400
      // },
      "&.Mui-disabled": {
        opacity: "35%"
      }
    }
  }
};

export const muiRadioStyle = createTheme({
  components: {
    MuiRadio: optionStyleOverrides
  }
});
